
const toggleSpMenu = () => {
    const btn = document.getElementById('js-hamburger-btn');

    if(!btn) return;

    const body = document.body;
    const pageTopBtn = document.querySelector('.c-page-top');
    const fixedFooterBtn = document.querySelector('.wp-block-lpc-blocks-fixed-button');

    btn.addEventListener('click', () => {
        body.classList.toggle('is-sp-nav-open');
        const isOpen = body.classList.contains('is-sp-nav-open');
        if (pageTopBtn) pageTopBtn.style.display = isOpen ? 'none' : '';
        if (fixedFooterBtn) fixedFooterBtn.style.display = isOpen ? 'none' : '';
    })
}
toggleSpMenu();

const closeSpMenu = () => {
    const bg = document.getElementById('js-close-sp-nav');

    if(!bg) return;

    const body = document.body;
    const pageTopBtn = document.querySelector('.c-page-top');
    const fixedFooterBtn = document.querySelector('.wp-block-lpc-blocks-fixed-button');

    bg.addEventListener('click', () => {
        body.classList.remove('is-sp-nav-open');
        if (pageTopBtn) pageTopBtn.style.display = '';
        if (fixedFooterBtn) fixedFooterBtn.style.display = '';
    })
}
closeSpMenu();

// ページトップボタンの表示タイミング
const handlePageTopBtn = () => {
    const pageTopBtn = document.querySelector('.c-page-top');
    if (!pageTopBtn) return;

    let isVisible = false;
    window.addEventListener('scroll', () => {
        if (window.scrollY > 300) {
            if (!isVisible) {
                pageTopBtn.style.opacity = '0.8';
                pageTopBtn.style.visibility = 'visible';
                pageTopBtn.style.pointerEvents = 'auto';
                isVisible = true;
            }
        } else {
            if (isVisible) {
                pageTopBtn.style.opacity = '0';
                pageTopBtn.style.visibility = 'hidden';
                pageTopBtn.style.pointerEvents = 'none';
                isVisible = false;
            }
        }
    });
};
window.addEventListener('DOMContentLoaded', handlePageTopBtn);
